export default "__VITE_ASSET__eDNvn44Y__"